import Color from 'color';
import styled from 'styled-components';

import {ms} from '@yourcoach/shared/styles/normalizeSize';
import {getColor, gts} from '@yourcoach/shared/styles/utils';
import {Button} from '@yourcoach/shared/uikit/Button';
import {Text} from '@yourcoach/shared/uikit/Text';
import {View} from '@yourcoach/shared/uikit/View';

export const Container = styled(View)`
  flex-direction: column;
`;

export const Header = styled(View)`
  justify-content: flex-end;
  align-items: center;
  gap: ${gts('gap.me')};
`;

export const ClientNameContainer = styled(View)`
  flex-direction: column;
  gap: ${ms(4)};
  padding-block-end: ${ms(20)};
`;

export const ClientName = styled(Text).attrs({
  variant: 'subtitle',
})``;

export const QuestionsList = styled(View)`
  flex-direction: column;
  gap: ${ms(20)};
`;

export const Footer = styled(View)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  padding-block-start: ${ms(20)};
`;

export const SubmitButton = styled(Button).attrs({size: 'l'})`
  width: ${ms(200)};
`;

export const Overlay = styled(View)`
  position: absolute;
  z-index: 3;
  inset: 0;
  justify-content: center;
  align-items: center;
  background: ${p => Color(getColor('background2')(p)).alpha(0.75).toString()};
`;
